import { useCallback } from "react";
import { _t, _k } from "@/helper/Translation";
import { t, exists } from 'i18next';
import i18next from "i18next";
import toNumber from "lodash/toNumber";
import { Translate } from '@/utils/Translate';

export const useTranslation = () => {
    
    const translate = useCallback((text, options = []) => {
        
        if (__DEV__) {
            checkKey(text)
        }

        return _t(text, options);
    }, [i18next.language]);

    const translateByKey = useCallback((text, options = [], translateOptions = false) => {
        if (text == null) {
            return text;
        }

        if (exists(text)) {
            
            let responseText = t(text);

            const regex = /\{{(.+?)\}}/g;
            const match = responseText?.match(regex);

            if (match == null)
                return responseText;

            match.map((item) => {
                const optionIndex = toNumber(item?.replace('{{', '')?.replace('}}', '')?.replace('$', ''));
                if (options[optionIndex] == null) {
                    //console.log('Translation not found for key: ' + item)
                    return;
                }
                
                if (translateOptions === true) {
                    options[optionIndex] = translateByKey(options[optionIndex]);
                }

                responseText = responseText.replace(item, options[optionIndex]);
            });
            
            return responseText;
            
        } else {
            //console.log('Translation not found for key: ' + text)
        }
        
        return text;
    }, [i18next.language, translate]);

    const createKey = useCallback((text) => _k(text) , [i18next.language]);
    
    const checkKey = useCallback((text) => {
        const keyObj = createKey(text);
        
        if (keyObj?.key == null) {
            return null;
        }

        if (!exists(keyObj?.key, {lng: 'en'})) {
            //console.log('Translation not found for EN-key: ');
            //console.log('"' + keyObj?.key +'": "' + keyObj?.text + '",');
            //console.log('----');
        }
    }, []);

    const pluralize = useCallback((count, singular, plural, options = {}) => {
        
        let response = '';

        if (options?.showCount && options?.position == 'before') {
            response += count;

            if (options?.seperator != null) {
                response += options?.seperator + ' ';
            } else {
                response += ' ';
            }

        }
        
        response += count == 1 ? translateByKey(singular, [count]) : translateByKey(plural, [count]);

        if (options?.showCount && options?.position == 'after') {
            
            if (options?.seperator != null) {
                response += options?.seperator + ' ';
            } else {
                response += ' ';
            }

            response += count;
        }

        return response;
    }, []);

    const Trans = (props) => <Translate {...props} />;

    return {
        translate,
        translateByKey,
        pluralize,
        t: translateByKey,
        createKey,
        checkKey,
        Trans,
    }
};

